import * as React from "react";

/** Breakpoint for mobile vs desktop. < 768px = mobile. Matches Tailwind `md`. */
export const MOBILE_BREAKPOINT = 768;

/** Generic media query hook for responsive logic */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = React.useState(false);

  React.useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

/** True when screen width < 768px. Drives Mobile (BottomTabBar + SidebarDrawer) vs Desktop (SidebarDesktop) layout. */
export function useIsMobile() {
  return useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
}
